(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rmit-tooltip"] && !Shopify.designMode) return;
  try {
    const TOOLTIP = ".rmit-tooltip";
const POPOUT = ".rmit-tooltip__popout";
const POPOUT_INNER = ".rmit-popout";
const TRIGGER = ".rmit-tooltip__trigger";
const TRIGGER_GAP = 6; //px
const ARROW_HEIGHT = 12; //px
const BORDER_WIDTH = 1; //px
const OPEN_CLASS = "is-open";
const POSITIONED_CLASS = "is-positioned";
const BELOW_CLASS = "is-below";

function getPopout(trigger) {
  return document.getElementById(trigger.getAttribute("aria-controls"));
}

function getTrigger(popout) {
  return popout.closest(TOOLTIP).querySelector(TRIGGER);
}

function getOpenPopouts() {
  return document.querySelectorAll(`${POPOUT}.${OPEN_CLASS}`);
}

function positionTooltip(popout, trigger) {
  const gap = ARROW_HEIGHT + TRIGGER_GAP;
  const viewportPadding = 8; // minimum px from viewport edge

  const triggerRect = trigger.getBoundingClientRect();
  const triggerCenter = triggerRect.left + triggerRect.width / 2;

  // Measure the popout at its natural width, then centre it on the trigger.
  popout.style.width = "";
  const popoutRect = popout.getBoundingClientRect();
  let popoutLeft = triggerCenter - popoutRect.width / 2;
  const popoutTop = triggerRect.bottom + gap;

  // Clamp horizontally so the tooltip stays within the viewport.
  const viewportWidth = document.documentElement.clientWidth;
  const minLeft = viewportPadding;
  const maxLeft = viewportWidth - popoutRect.width - viewportPadding;
  popoutLeft = Math.round(Math.max(minLeft, Math.min(popoutLeft, maxLeft)));

  // If there's not enough room above the trigger, show it below instead.
  const below = triggerRect.top < popoutRect.height + gap;

  const topPos = below
    ? Math.round(popoutTop)
    : Math.round(triggerRect.top - popoutRect.height - gap);

  popout.style.left = `${popoutLeft}px`;
  popout.style.top = `${topPos}px`;

  // Align the arrow so it still points at the centre of the trigger,
  // even when the popout has been shifted to stay on-screen.
  const rmitPopout = popout.querySelector(POPOUT_INNER);
  const rmitPopoutRect = rmitPopout.getBoundingClientRect();
  const arrowOffset = Math.round(triggerCenter - rmitPopoutRect.left - BORDER_WIDTH);
  rmitPopout.style.setProperty("--rmit-tooltip-arrow-left", `${arrowOffset}px`);

  popout.classList.toggle(BELOW_CLASS, below);
  popout.classList.add(POSITIONED_CLASS);
}

function showTooltip(popout, trigger) {
  trigger.setAttribute("aria-expanded", "true");
  popout.setAttribute("aria-hidden", "false");
  popout.classList.add(OPEN_CLASS);
  positionTooltip(popout, trigger);
}

function hideTooltip(popout) {
  getTrigger(popout).setAttribute("aria-expanded", "false");
  popout.classList.remove(OPEN_CLASS, POSITIONED_CLASS);
  popout.setAttribute("aria-hidden", "true");
}

function resetTooltips() {
  getOpenPopouts().forEach(hideTooltip);
}

document.addEventListener("pointerover", (e) => {
  if (e.pointerType !== "mouse") {
    return;
  }

  const trigger = e.target.closest(TRIGGER);
  if (!trigger) {
    return;
  }

  const popout = getPopout(trigger);
  showTooltip(popout, trigger);
});

document.addEventListener("pointerout", (e) => {
  if (e.pointerType !== "mouse") {
    return;
  }

  const wrapper = e.target.closest(TOOLTIP);
  if (!wrapper) {
    return;
  }

  const popout = wrapper.querySelector(POPOUT);
  if (e.relatedTarget?.closest(TOOLTIP) === wrapper) {
    return;
  }

  hideTooltip(popout);
});

document.addEventListener("click", (e) => {
  const trigger = e.target.closest(TRIGGER);
  if (!trigger) {
    if (!e.target.closest(TOOLTIP)) {
      resetTooltips();
    }
    return;
  }

  const popout = getPopout(trigger);
  if (popout.classList.contains(OPEN_CLASS)) {
    hideTooltip(popout);
  } else {
    showTooltip(popout, trigger);
  }
});

document.addEventListener("scroll", () => {
  resetTooltips();
}, { capture: true, passive: true });
  } catch(e) { console.error(e); }
})();

})();
